import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from 'app/utils';
import moment from 'moment';

@Pipe({
	name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
	transform(date: Date | null | undefined, format?: string): string {
		if (!date) {
			return '--';
		}

		const defaultFormat = 'D MMM YYYY';
		const dateFormat = format || defaultFormat;

		return moment(Utils.utcToLocalDate(date)).format(dateFormat);
	}
}
